const NOME_PROJETO = 'AS';
const TEXTO_SEM_DADOS = 'Sem dados para exibir';

export { NOME_PROJETO, TEXTO_SEM_DADOS };
